module.exports = __webpack_public_path__ + "img/fa-regular-400.ab47fae.svg";